import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Button, Box } from '@mui/material';
import MultipleChipSelect from '../../../../Components/Inputs/MultipleChipSelect';
import { STATUSES_OPTIONS } from '../../Utils/constants';

const useStyles = () => ({
  root: {
    padding: '8px 16px',
    width: '25vw',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
});

const ImportsFilterWidget = function ImportsFilterWidget({
  defaultValues = {},
  onConfirm = () => {},
  sections = [],
  onClose = () => {},
}) {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });
  const classes = useStyles();
  const [statuses, setStatuses] = useState([]);
  const [selectedSections, setSelectedSections] = useState([]);

  const handleChangeStatuses = (newValues) => {
    setStatuses(newValues);
  };

  const handleChangeSelectedSections = (newValues) => {
    setSelectedSections(newValues);
  };

  const handleConfirm = () => {
    const completedOn = statuses.find((x) => x === 'processing');
    const completed = statuses.find((x) => x === 'completed');
    const error = statuses.find((x) => x === 'error');

    const filters = {
      sectionName: selectedSections.length > 0 ? selectedSections : null,
      isSuccessful:
        (completed && error) || (!completed && !error)
          ? null
          : !!(completed && !error),
      completedOn: completedOn ? '2000-01-01' : null,
    };

    onConfirm(filters);
    onClose();
  };

  useEffect(() => {
    if (defaultValues) {
      setSelectedSections(defaultValues?.sectionName || []);
      setStatuses([
        ...(defaultValues?.completedOn ? ['processing'] : []),

        ...(defaultValues?.isSuccessful
          ? ['completed']
          : defaultValues?.isSuccessful === false
            ? ['error']
            : []),
      ]);
    }
  }, [defaultValues]);

  return (
    <div style={classes.root}>
      <MultipleChipSelect
        label={t('SECTIONS')}
        options={sections.map(({ name }) => name)}
        values={selectedSections}
        onChange={handleChangeSelectedSections}
      />
      <MultipleChipSelect
        label={t('STATUS')}
        onChange={handleChangeStatuses}
        values={statuses}
        options={STATUSES_OPTIONS}
      />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          position: "sticky",
          bottom: 0
        }}>
        <Button
          id="confirm-filters-btn"
          size="large"
          sx={{ mt: '16px' }}
          onClick={handleConfirm}
        >
          {t('CONFIRM')}
        </Button>
      </Box>
    </div>
  );
};

ImportsFilterWidget.propTypes = {
  sections: PropTypes.array,
  defaultValues: PropTypes.object,
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
};
export default ImportsFilterWidget;
